import { http } from '../request'
import {
  normalizeListResponse,
  normalizePageResponse
} from './shared'

export interface StaffPositionInfo {
  positionId: number
  positionName: string
  /** 管辖年级ID（仅年级组长岗位有值） */
  gradeId?: number
  scopeType?: string
  classIds?: number[]
}

export interface StaffDto {
  id: number
  staffNo?: string
  name: string
  gender: string
  phone?: string
  departmentId?: number
  departmentName?: string
  isTeachingStaff?: boolean
  employmentStatus: string
  hireDate?: string
  leaveDate?: string
  hasAccount: boolean
  userId?: number
  roleIds?: number[]
  positions: StaffPositionInfo[]
  /** 是否担任班主任（来自班级事实，只读） */
  headTeacher?: boolean
  username?: string | null
}

type StaffPageResponse = {
  items: StaffDto[]
  total: number
  page: number
  pageSize: number
}

export interface BatchOpenAccountResult {
  /** 本次开通使用的初始密码；无人开通时为空 */
  initialPassword: string | null
  opened: {
    staffId: number
    name: string
    staffNo?: string
    phone?: string
    username: string
  }[]
  /** 已有账号、本次跳过的人员ID */
  skippedIds: number[]
  failed: {
    staffId: number
    name?: string
    reason: string
  }[]
}

export const staffApi = {
  async list(params?: Record<string, unknown>): Promise<StaffPageResponse> {
    const response = await http.get<StaffPageResponse>('/data-management/staff', params)
    return normalizePageResponse<StaffDto>(response.data)
  },
  async create(payload: Partial<StaffDto> & Record<string, unknown>): Promise<StaffDto> {
    const response = await http.post<StaffDto>('/data-management/staff', payload)
    return response.data
  },
  async update(id: number, payload: Partial<StaffDto> & Record<string, unknown>): Promise<StaffDto> {
    const response = await http.put<StaffDto>(`/data-management/staff/${id}`, payload)
    return response.data
  },
  async remove(id: number): Promise<void> {
    await http.delete<void>(`/data-management/staff/${id}`)
  },
  async batchRemove(ids: number[]): Promise<void> {
    await http.post<void>('/data-management/staff/batch-delete', { ids })
  },
  /** 批量开通登录账号：已开通的自动跳过，开不了的单独回原因 */
  async batchOpenAccount(ids: number[], roleIds: number[]): Promise<BatchOpenAccountResult> {
    const response = await http.post<BatchOpenAccountResult>('/data-management/staff/batch-open-account', { ids, roleIds })
    return response.data
  },
  async listTeachingStaff(): Promise<StaffDto[]> {
    const response = await http.get<StaffDto[]>('/data-management-lookup/staff/teaching')
    return normalizeListResponse<StaffDto>(response.data)
  },
  async checkNameDuplicate(name: string, excludeId?: number): Promise<boolean> {
    const response = await http.get<boolean>('/data-management/staff/check-name', { name, excludeId })
    return Boolean(response.data)
  }
}
